import { CustomTip } from 'components/atoms/tooltipCustom'
import { Link } from 'react-router-dom'
import { ContactsTable, StackIcon } from 'shared/ui'

import type { Action } from '../../types'

export function Message({
	hint,
	id
}: Action & {
	id?: null | string
}) {
	if (id) {
		return (
			<CustomTip arrow title={hint}>
				<Link
					className={ContactsTable.css.cellAction}
					to={`/messaging/thread/${id}`}
				>
					<StackIcon icon='message' width={18} />
				</Link>
			</CustomTip>
		)
	}

	return (
		<button className={ContactsTable.css.cellAction} disabled type='button'>
			<StackIcon icon='message' width={18} />
		</button>
	)
}
